<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<h1 class="chapter"><a id="page81"></a><a class="hlink" href="#/text/9780062378576_B1_Contents#deda"><em>Dedication</em></a></h1>
<p class="center">For my mum,<br/>the most important woman in my life,<br/>this book is dedicated to you.<br/>Now for God’s sake don’t read it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062378576_B1_Dedication.vue?6a62f566